import Styled from "./styles";

interface EarlyWarningInfoProps {
  content: string;
}

const EarlyWarningInfo = ({ content }: EarlyWarningInfoProps) => {
  return (
    <Styled.InfoWrapper>
      <h3 style={{ marginTop: 0 }}>Toelichting</h3>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Styled.InfoWrapper>
  );
};

export default EarlyWarningInfo;
